<router-outlet></router-outlet>

<ng-template #submenuContent>
    <div class="subSideMenu">
        @let active = store.activeIndex$ | async;
        @if (active) {
            <ul class="list-none px-3">
                @for (item of menuItems(); track item) {
                    <li class="subSideMenu-item">
                        <div
                            pRipple
                            [ngClass]="{
                                'subSideMenu-link': true,
                                'subSideMenu-link_active': item === active,
                                'subSideMenu-link_disabled': item !== active && !this.serviceId,
                             }"
                            (click)="itemOnClick(item)"
                        >
                            {{ 'database.servicesAdministrationPage.sidebar.' + item | translate }}
                        </div>
                    </li>
                }
            </ul>
        }
    </div>
</ng-template>
